<template>
  <div class="container">
    <div class="left-div">
      <div>
        <div class="title">
          <!--标签-->
          <div>
            <div class="name">
              {{ testPagerReadStudentDetail.testPaperName }}
            </div>
          </div>
          <div class="text">
            <div>
              共{{ testPagerReadStudentDetail.testTotalNum }}道题 共{{
                testPagerReadStudentDetail.testTotalScore
              }}分
            </div>
          </div>
        </div>
        <div v-if="downLoadDisFlg=='1'">
          <v-btn
            class="my-0 mx-4"
            color="primary"
            @click="downloadFile"
            style="display: flex;
              width: 100px;
              height: 38px;
              background: #0171A3;
              border-radius: 5px;
              color: #FEFEFE;
              justify-content: center;
              align-items: center;
              margin: 0 0.5em 0 0;
              cursor: pointer;
              font-size: 14px;
              padding: 0 1em;
              float: right;"
          >
            下载资料
          </v-btn>
        </div>
        <div
          v-for="(testPaperReadItem,
          testPagerReadIndex) in testPagerReadQuetionList"
          :key="testPagerReadIndex"
          style="width: 60%; margin: 10px"
        >
          <div class="top-zero bottom-zero" style="margin-top: -10px">
            <div>
              <!--标签-->
              <div class="pa-0">
                <div
                  class="content"
                  style="
                    margin-top: 25px;
                    margin-left: 27px;
                    text-align: start;
                    font-weight: bold;
                  "
                >
                  {{ testPagerReadIndex + 1 }}.{{
                    testPaperReadItem.questionContent
                  }}
                  <span class="questionScore">
                    ({{ testPaperReadItem.questionScore }}分)
                  </span>
                </div>
              </div>
            </div>
            <div
              v-for="(item, index) in testPaperReadItem.actualFileVOList"
              :key="index"
            >
              <!--标签-->
              <div class="pa-0">
                <div style="margin-left: 30px;margin-top:10px">
                <video v-if="item.fileType == '02'" class="video" :src="item.fileUrl" controls/>
                <viewer>
                <img
                  v-if="item.fileType =='01'"
                  :data-source="item.fileUrl"
                  :src="item.fileUrl? item.fileUrl:require('@/assets/avatar.jpg')"
                  width="200px"
                  height="220px"
                />
                </viewer>
                </div>
              </div>
            </div>
            <div
              style="
                width: 900px;
                margin: 30px;
                height: 40px;
                background-color: #eeeeee;
              "
            >
              <div>
                <!--标签-->
                <div class="pa-0">
                  <div
                    class="score-content"
                  >
                    <span style="margin-top:7px;">得分：</span>
                    <input
                      class="score_class"
                      v-model="testPaperReadItem.studentAnswerVO.score"
                      @blur="checkStudentScore(testPaperReadItem)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--作业评语--结束-->
          </div>
        </div>
      </div>
      <div>
        <div>
          <!--标签-->
          <div
            style="
              margin-top: 25px;
              margin-left: 42px;
              font-size: 16px;
              font-weight: bold;
              font-weight: bold;
            "
          >
            作业评语
          </div>
        </div>
        <!--题目-->
        <div style="margin-left: 42px">
          <BInputTextArea style="height: 150px; width: 97%;" v-model="testPagerReadStudentDetail.remarks"/>
        </div>
      </div>
    </div>

    <div class="main-right">
      <!--标签-->
      <div class="box-right">
        <div class="inner-box">
          <div>
            <img
              style="width: 50px; height: 50px; border-radius: 50%"
              :src="require('../../assets/avatar.jpg')"
            />
          </div>
          <div>
            <div style="margin-left: 5px">
              {{ paperReadStudent.studentName }}
            </div>
            <div style="margin-left: 5px">
              {{ paperReadStudent.trainClassName }}
            </div>
          </div>
        </div>
        <div>
          <!--标签-->
          <div class="scoreContent">
            <div class="score-text">得分：</div>
            <div class="score-value">
              {{ testPagerReadStudentDetail.studentScore }}分
            </div>
          </div>
          <div v-if="reviewStatus !== '03'" class="inner-line">
            <div v-if="disabledFlag === false" style="font-size: 16px;text-valign: left；text-align: end; ">
              <BBtnPrimary
                :clicked="btnSubmitNext"
                btn-txt="提交并进入下一份"
                :disabled="String(disabledFlag)"
              />
            </div>
            <div v-if="disabledFlag === false" style="font-size: 16px; text-valign: left；">
              <BBtnPrimary
                :clicked="btnSubmit"
                btn-txt="提交"
                :disabled="String(disabledFlag)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { actualDetail, actualSave } from "@/api/testPaperRead";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputTextArea from "../../components2/BInputTextArea";
import Vue from "vue";
export default {
  components: {
    BBtnPrimary,
    BInputTextArea,

  },
  name: "StudentManagement",
  data: () => ({
    searchParam: {},
    snackbarText: "",
    id: 0,
    paperReadStudent: {}, //左侧学员信息
    testPagerReadQuetionList: [],
    testPagerReadStudentDetail: {
      testPaperName: "",
      testTotalNum: 0,
      testTotalScore: 0,
      remarks: "",
      studentScore: 0,
    },
    disabledFlag: false,
    downLoadDisFlg: "0",
    checkFlag: "",
    reviewStatus: "",
  }),
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        studentTestPaperId: vm.$route.query.studentTestPaperId,
      };
      // 参数赋值 班级id
      if (
        params.studentTestPaperId !== undefined &&
        params.studentTestPaperId !== null &&
        params.studentTestPaperId !== ""
      ) {
        vm.checkFlagFun(params);
        if (vm.checkFlag !== false) {
          // 把不为空的参数存入缓存
        vm.$store.commit("SET_TEST_PAPER_READ_ADD_PARAMS", params);
        }
        
      }

      // 参数赋值 发布试卷的id
      if (
        vm.$store.state.testPagerRead_studentTestPaperId !== undefined &&
        vm.$store.state.testPagerRead_studentTestPaperId !== null &&
        vm.$store.state.testPagerRead_studentTestPaperId !== ""
      ) {
        vm.studentTestPaperId =
          vm.$store.state.testPagerRead_studentTestPaperId;
      }
      const searchParam = {
        studentTestPaperId: vm.studentTestPaperId,
      };
      vm.getTestPagerDetail(searchParam);
    });
  },
  methods: {
    async checkFlagFun(params) {
      const data = await actualDetail(params);
       // 批阅状态
      this.reviewStatus = data.data.readFlag
      this.downLoadDisFlg = data.data.downLoadDisFlg
      // 是否已批阅
      if (data.data.readFlag === "03") {
        this.checkFlag = false;
      }
    },
    // 点击详情
    getTestPagerDetail(item) {
      this.fetchData(item);
    },
    async fetchData(params) {
      const data = await actualDetail(params);
      this.paperReadStudent = data.data.paperReadStudentVO;
      this.testPagerReadQuetionList = data.data.actualQuestionVOList;
      this.testPagerReadStudentDetail = data.data.testPagerReadStudentDetailVO;
      if(this.testPagerReadStudentDetail.studentScore=="" || this.testPagerReadStudentDetail.studentScore==null){
        this.testPagerReadStudentDetail.studentScore = 0;
      }
    },
    // 每题分数验证
    checkStudentScore(testPaperReadItem) {
      if (
        String(testPaperReadItem.studentAnswerVO.score) !==
          String(testPaperReadItem.studentAnswerVO.score)
            .replace(/[^\\.\d]/g, "")
            .replace(".", "")
      ) {
        this.snackbarText = "输入的分数必须为正整数！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        testPaperReadItem.studentAnswerVO.score = 0
        return;
      }

      // 
      if(parseInt(testPaperReadItem.studentAnswerVO.score) > testPaperReadItem.questionScore){
        this.snackbarText = "输入的分数不能大于题目分数！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        testPaperReadItem.studentAnswerVO.score = 0
        return;
      }

      var totalScore = 0;
      for (var i = 0; i < this.testPagerReadQuetionList.length; i++) {
        totalScore += parseInt(
          this.testPagerReadQuetionList[i].studentAnswerVO.score
        );
      }
      this.testPagerReadStudentDetail.studentScore = totalScore;
    },

    // 作业评语
    remarksCheck(remarks) {
      if (remarks === null || remarks === "") {
        this.snackbarText = "作业评语必须输入！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        return;
      }
      if (remarks.length > 255) {
        this.snackbarText = "作业评语不能超过225位！";
        Vue.prototype.$valertbar.show(this.snackbarText);
      }
    },

    // 总分验证
    checkItemScore() {
      var list = this.testPagerReadQuetionList;
      for (var i = 0; i < list.length; i++) {
        // 每题得分
        var score = list[i].studentAnswerVO.score;
        if (score === null || score === "") {
          this.snackbarText = "第" + (i + 1) + "道题目的得分必须输入！";
          Vue.prototype.$valertbar.show(this.snackbarText);
          return;
        }
        if (
          String(score) !==
            String(score)
              .replace(/[^\\.\d]/g, "")
              .replace(".", "") 
        ) {
          this.snackbarText = "第" + (i + 1) + "道题目输入的得分必须为正整数！";
          Vue.prototype.$valertbar.show(this.snackbarText);
          return;
        }
      }
    },
    // 提交
    btnSubmit(){
      this.doSubmit(false);
    },
    // 提交并进入下一个
    btnSubmitNext(){
      this.doSubmit(true);
    },
    
    // // 提交
    // async btnSubmit() {
    //   // 验证
    //   this.snackbarText = "";
    //   // 总分验证
    //   this.checkItemScore();
    //   if (this.snackbarText !== "") {
    //     return;
    //   }

    //   var totalScore = 0;
    //   for (var i = 0; i < this.testPagerReadQuetionList.length; i++) {
    //     totalScore += parseInt(
    //       this.testPagerReadQuetionList[i].studentAnswerVO.score
    //     );
    //   }
    //   this.testPagerReadStudentDetail.studentScore = totalScore;

    //   // if (this.testPagerReadStudentDetail.studentScore === 0) {
    //   //   this.snackbarText = "学员总得分必须为正整数！";
    //   //   Vue.prototype.$valertbar.show(this.snackbarText);
    //   //   return;
    //   // }

    //   this.remarksCheck(this.testPagerReadStudentDetail.remarks);
    //   if (this.snackbarText !== "") {
    //     return;
    //   }

    //   // 答題列表
    //   var array = []
    //   for (var j=0;j<this.testPagerReadQuetionList.length;j++) {
    //     var obj = {
    //       studentTestQuestionsID: this.testPagerReadQuetionList[j].studentAnswerVO.studentTestQuestionsID,
    //       score: this.testPagerReadQuetionList[j].studentAnswerVO.score,
    //     }
    //     array.push(obj)
    //   }
    //   var addParam = {};
    //   addParam.id = this.testPagerReadStudentDetail.id;
    //   addParam.score = this.testPagerReadStudentDetail.studentScore;
    //   addParam.remarks = this.testPagerReadStudentDetail.remarks;
    //   addParam.studentAnswerList = array
    //   // 发布id
    //   addParam.testPaperReleaseId = '';
    //   const data = await actualSave(addParam);
    //   if (data.code === 0) {
    //     Vue.prototype.$vsnackbar.show(data.msg);
    //     // 提交之后 两个按钮都禁用
    //     this.disabledFlag = true;

    //   } else {
    //     this.snackbarText = data.msg;
    //     Vue.prototype.$valertbar.show(this.snackbarText);
    //   }
    // },
    // 提交并进行下一个
    async doSubmit(nextFlg) {
      // 验证
      this.snackbarText = "";
      // 总分验证
      this.checkItemScore();
      if (this.snackbarText !== "") {
        return;
      }

      var totalScore = 0;
      for (var i = 0; i < this.testPagerReadQuetionList.length; i++) {
        totalScore += parseInt(
          this.testPagerReadQuetionList[i].studentAnswerVO.score
        );
      }
      this.testPagerReadStudentDetail.studentScore = totalScore;

      if (this.testPagerReadStudentDetail.studentScore === 0) {
        this.snackbarText = "学员总得分必须为正整数！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        return;
      }

      this.remarksCheck(this.testPagerReadStudentDetail.remarks);
      if (this.snackbarText !== "") {
        return;
      }

      // 答題列表
      var array = []
      for (var j=0;j<this.testPagerReadQuetionList.length;j++) {
        var obj = {
          studentTestQuestionsID: this.testPagerReadQuetionList[j].studentAnswerVO.studentTestQuestionsID,
          score: this.testPagerReadQuetionList[j].studentAnswerVO.score,
        }
        array.push(obj)
      }
      var addParam = {};
      addParam.id = this.testPagerReadStudentDetail.id;
      addParam.score = this.testPagerReadStudentDetail.studentScore;
      addParam.remarks = this.testPagerReadStudentDetail.remarks;
      addParam.studentAnswerList = array;
      // 发布id
      addParam.testPaperReleaseId = this.studentTestPaperId;
      const data = await actualSave(addParam);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        if (nextFlg) {
          if (
            data.data.studentTestPaperId !== null &&
            data.data.studentTestPaperId !== undefined &&
            data.data.studentTestPaperId !== "" &&
            data.data.studentTestPaperId !== 0
          ) {
            this.testPagerDetail(data.data.studentTestPaperId);
          } else {
            //已经批阅完毕
            this.reviewStatus = '03'
          }
        } else {
          //已经批阅完毕
          this.reviewStatus = '03'
          // 提交之后 两个按钮都禁用
          this.disabledFlag = true;
        }
      } else {
        this.snackbarText = data.msg;
        Vue.prototype.$valertbar.show(this.snackbarText);
      }
    },
    async testPagerDetail(studentTestPaperId) {
      const params = {
        studentTestPaperId: studentTestPaperId,
      };
      this.$store.commit("SET_TEST_PAPER_READ_ADD_PARAMS", params);
      this.studentTestPaperId = this.$store.state.testPagerRead_studentTestPaperId;
      const searchParam = {
        studentTestPaperId: this.studentTestPaperId,
      };
      this.getTestPagerDetail(searchParam);
    }, 
    downloadFile () {
      window.location.href =
        process.env.VUE_APP_BASE_API+'/api/TestPaperRead/downloadFile?studentTestPaperId='+this.studentTestPaperId
    }
  },
};
</script>

<style lang="scss" scoped>
.testDiv {
  border: solid 1px #385f73;
}
.search {
  max-width: 30%;
}

.topAndBottom {
  padding-bottom: 0px;
  padding-top: 0px;
}
.top {
  padding-top: 0px;
}
.bottom {
  padding-bottom: 0px;
}

.container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 50px;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.name {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
}
.text {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.left-div {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  width: 70%;
  height: 680px;
  overflow-y: scroll;
}
.main-right {
  width: 30%;
  background: #f9f9f9;
  height: 400px;
  margin-left: 20px;
}

.inner-box {
  display: flex;
  flex-direction: row;
}

.scoreContent {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 100px;
}
.score-text {
  margin-top: 7px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.score-value {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.inner-line {
  display: flex;
  flex-direction: row;
}
.box-right {
  margin-left: 20px;
  margin-top: 20px;
}
.toalScore-text {
  margin-top: 5px;
}
.score_class {
  border: none;
  width: 100px;
  height: 20px;
  justify-content: flex-end;
  margin-right: 20px;
  margin-top: 10px;
}
.content {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.questionScore {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #b3bbbe;
}
.score-content {
  display: flex; 
  font-size: 16px;
  justify-content: space-between;
}
.video {
  width: 448px;
  height: 273px;
  background: #000000;
}
</style>
